import React, { useState, useEffect, Suspense } from "react";
import DnsRoundedIcon from '@material-ui/icons/DnsRounded';
import SecurityRoundedIcon from '@material-ui/icons/SecurityRounded';
import BeenhereRoundedIcon from '@material-ui/icons/BeenhereRounded';
import ReplayRoundedIcon from '@material-ui/icons/ReplayRounded';
// components

import CardStats from "components/Cards/CardStats.js";

export default function HeaderStats() {

  const [countlist, setlists] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/count`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setlists(resp))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  return (
    <>
                {/* Card stats */}
            <div className="flex flex-wrap">
              <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="HOSTs"
                  statTitle={countlist.host_count}
                  statPercent={countlist.host_connected}
                  stateResult="Connected"                 
                  statPercentColor="text-emerald-500"
                  statDescription={countlist.host_disconnected}
                  statDescriptionColor="text-red-500"
                  stateResult1="Not connected"
                  statIconName="far fa-chart-bar"
                  statIconColor="bg-red-500"
                />
              </div>
              <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="AUDITs"
                  statTitle={countlist.audit_count}
                  statPercent={countlist.audit_success}
                  stateResult="Successed"
                  statPercentColor="text-emerald-500"
                  statDescription={countlist.audit_failed}
                  statDescriptionColor="text-red-500"
                  stateResult1="Failed"
                  statIconName="fas fa-shield-alt"
                  statIconColor="bg-orange-500"
                />
              </div>
              <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="REMEDY"
                  statTitle={countlist.remedy_count}
                  statPercent={countlist.remedy_success}
                  stateResult="Successed"
                  statPercentColor="text-emerald-500"
                  statDescription={countlist.remedy_failed}
                  statDescriptionColor="text-red-500"
                  stateResult1="Failed"
                  statIconName="fas fa-check-square"
                  statIconColor="bg-pink-500"
                />
              </div>
              <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="ROLLBACK"
                  statTitle={countlist.rollback_count}
                  statPercent={countlist.rollback_success}
                  stateResult="Successed"
                  statPercentColor="text-emerald-500"
                  statDescription={countlist.rollback_failed}
                  statDescriptionColor="text-red-500"
                  stateResult1="Failed"
                  statIconName="fas fa-reply"
                  statIconColor="bg-lightBlue-500"
                />
              </div>
            </div>    
    </>
  );
}
